import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import brandPortalOrdersbrandOrderTokenOrderFulfilment from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/order-fulfilment";
import brandPortalPayouts from "@faire/web-api/routes/brand-portal/payouts";
import React from "react";
import { PayoutNotReceivedIA } from "./instantAnswersComponents/payments/PayoutNotReceivedIA";
export var PayoutNotReceived = function PayoutNotReceived(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return PAYOUT_NOT_RECEIVED_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return PAYOUT_NOT_RECEIVED_DESCRIPTION(context);
    }
  };
};
var PAYOUT_NOT_RECEIVED_TITLE = function PAYOUT_NOT_RECEIVED_TITLE(strictLocalize) {
  return strictLocalize({
    id: "5fNbAD",
    defaultMessage: [{
      "type": 0,
      "value": "Comprendre les retards de paiement"
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var _brandOrder$brand_ord;
  var brandOrder = context.brandOrder;
  if (brandOrder && (_brandOrder$brand_ord = brandOrder.brand_order) !== null && _brandOrder$brand_ord !== void 0 && _brandOrder$brand_ord.token) {
    return {
      label: strictLocalize({
        id: "FGACeH",
        defaultMessage: "View your payout"
      }),
      getLink: function getLink() {
        var _brandOrder$brand_ord2, _brandOrder$brand_ord3;
        return brandPortalOrdersbrandOrderTokenOrderFulfilment((_brandOrder$brand_ord2 = (_brandOrder$brand_ord3 = brandOrder.brand_order) === null || _brandOrder$brand_ord3 === void 0 ? void 0 : _brandOrder$brand_ord3.token) !== null && _brandOrder$brand_ord2 !== void 0 ? _brandOrder$brand_ord2 : "", {
          sync: "true"
        });
      }
    };
  }
  return {
    label: strictLocalize({
      id: "TQMpU3",
      defaultMessage: "View your payouts"
    }),
    getLink: function getLink() {
      return brandPortalPayouts();
    }
  };
};
var PAYOUT_NOT_RECEIVED_DESCRIPTION = function PAYOUT_NOT_RECEIVED_DESCRIPTION(_context) {
  return /*#__PURE__*/React.createElement(PayoutNotReceivedIA, null);
};